module.exports = __webpack_public_path__ + "static/media/WM3@1.5x.a26f6356.png";